import { Polyline, PolylineOptions } from '../../types';
import { Map } from "common/utils/Map/types";

export class HerePolyline implements Polyline {
  private _polyline?: H.map.Polyline;
  private _map: Map;

  constructor(map: Map, options?: PolylineOptions) {
    this._map = map;
    this._createPolyline(options);
    this._addPolylineOnMap();
  }

  _createPolyline(options?: PolylineOptions) {
    const {
      path = [],
      strokeWeight: lineWidth,
      strokeColor,
      zIndex = 0
    } = options || {};

    const lineString = new H.geo.LineString();

    path.forEach(({ lat, lng }) => {
      lineString.pushPoint({ lat, lng });
    });

    this._polyline = new H.map.Polyline(lineString, {
      style: {
        lineWidth,
        strokeColor
      },
      zIndex
    });    
  }

  _addPolylineOnMap() {
    const nativeMap = this._map.getNativeMap();
  
    if (this._polyline && nativeMap) {
      nativeMap.addObject(this._polyline);
    }
  }

  delete() {
    const nativeMap = this._map.getNativeMap();

    if (this._polyline) {
      nativeMap.removeObject(this._polyline);
    }
  }
}